// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"cb262840","787":"a71f9353"}[chunkId] + ".chunk.js";
};